import React__default from 'react';
import { Icon } from 'react-lazy-svg';
import LazyLoad from 'react-lazyload';
import { ExternalSvgMapper } from './externalSvgMapper.js';

const IconExternal = ({ iconUri, className, width, height }) => {
    const svgUrl = ExternalSvgMapper[iconUri];
    const style = {};
    if (width) {
        style.width = parseInt(width);
    }
    if (height) {
        style.height = parseInt(height);
    }
    const placeholder = React__default.createElement("div", { "data-qa": "icon-external", className: className, style: style });
    if (svgUrl) {
        return (React__default.createElement(LazyLoad, { offset: 2000, placeholder: placeholder },
            React__default.createElement(Icon, { url: svgUrl, className: className, width: width, height: height, "data-qa": 'svg-icon' })));
    }
    return null;
};

export { IconExternal };
